import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const timeline = {
    get: {
        // @Url /v1/calendars/timeline/staff/{cbidx} 
        staffTimeline: async (params) => {
            return await http.get(
                `${URLs.calendars}/timeline/staff/${params.cbidx}`,
                {
                    params: params
                }
            )
        },
        // @Url /v1/calendars/timeline/recipient/{cbidx}
        recipientTimeline: async (params) => {
            return await http.get(
                `${URLs.calendars}/timeline/recipient/${params.cbidx}`,
                {
                    params:params
                }
            )
        },
    },
    post: {
        // @Url /v1/calendars/{cbidx}/change-receiver-offer-schedule-staff/{idx}
        changeReceiverOfferScheduleStaff: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.calendars}/${params.cbidx}/change-receiver-offer-schedule-staff/${params.idx}`,
                formData
            )
        },
    },
    delete: {
        // @Url /v1/calendars/{cbidx}/change-receiver-offer-schedule/{idx}
        changeReceiverOfferSchedule: async (params) => {
            return await http.delete(
                `${URLs.calendars}/${params.cbidx}/change-receiver-offer-schedule/${params.idx}`,
                {
                    params: params
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/timelines.js